import { connect } from 'react-redux';
import { InsightsViaEmailListComponent } from './InsightsViaEmail-list.component';

const mapStateToProps = (state) => ({
  lang: state.lang.INSIGHTS_VIA_EMAIL.LIST
})

export const InsightsViaEmailList = connect(mapStateToProps)(InsightsViaEmailListComponent)